module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAxUlEQVR42u3auwnDMBAAUK3gJbyIVtDQbuxag7i/dCa4SIIsbIie4GodT7/jUIqINHIkAAAAAAAAAAAAAAAA3DNS+hz3DQAAADQC7MsaNZeoucS+rI8BXMrj6g7Ypjm2aX58BzTn0QLwrnye+OcV6ADQJY8WgJrLMeE5ai63AXTJA4Aj4BL0DCqEAAAAcAB8S+zfAgAAAAAAAACgEAIAAICGiJaYpqi2OABHwCXoGVQIAQAwNoCfogAAAAAAAAAAAAAAjBMvBbGRj1pEQwIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Georgia.png
// module id = lmpj
// module chunks = 0 62 63